<app-component-subnav></app-component-subnav>

<main>
  <h2>PPS  <cds-icon shape="two-way-arrows"></cds-icon>  Komponenten <span *ngIf="!activeState"> <cds-icon shape="two-way-arrows"></cds-icon>  Passiv!</span></h2>
  <clr-datagrid [clrDgLoading]="loading">
    <clr-dg-column [clrDgField]="'technical_drawing'">Zeichnungsnummer</clr-dg-column>
    <clr-dg-column [clrDgField]="'name'">Bezeichnung</clr-dg-column>
    <clr-dg-column [clrDgField]="'material'">Material</clr-dg-column>
    <clr-dg-column [clrDgField]="'manufacturer'">Hersteller</clr-dg-column>
    <clr-dg-column [clrDgField]="'guideline_price'">Richtpreis (EUR/Stück)</clr-dg-column>
    <clr-dg-column [clrDgField]="'weight'">Gewicht (in kg)</clr-dg-column>
    <clr-dg-column [clrDgField]="'taric'">Zolltarifnummer</clr-dg-column>
    <clr-dg-column [clrDgField]="'description'">Kurzbeschreibung</clr-dg-column>
    <clr-dg-column [clrDgField]="'specification'">Spezifikation</clr-dg-column>
    <clr-dg-column [clrDgField]="'number_of_pieces_in_stock'">Lagerbestand (Warehouse)</clr-dg-column>
    <clr-dg-placeholder>We couldn't find any Component!</clr-dg-placeholder>
    <clr-dg-row *clrDgItems="let component of components" [routerLink]="['/component/details', component.technical_drawing]">
      <clr-dg-cell>{{ component.technical_drawing }}</clr-dg-cell>
      <clr-dg-cell><b>{{ component.name }}</b>&nbsp;  <cds-icon *ngIf="component.standard" shape="node"></cds-icon>  <cds-icon *ngIf="component.technology" shape="cog"></cds-icon></clr-dg-cell>
      <clr-dg-cell>{{ component.material_name }}</clr-dg-cell>
      <clr-dg-cell>{{ component.manufacturer }}</clr-dg-cell>
      <clr-dg-cell class="currency"><b>{{ component.guideline_price | currency: 'EUR':'code':'1.2-2':'de' }}</b></clr-dg-cell>
      <clr-dg-cell class="currency">{{ component.weight }}</clr-dg-cell>
      <clr-dg-cell *ngIf="component.taric && component.taric !== '0'">{{ component.taric }}</clr-dg-cell>
      <clr-dg-cell *ngIf="!component.taric || component.taric === '0'"></clr-dg-cell>
      <clr-dg-cell>{{ component.description }}</clr-dg-cell>
      <clr-dg-cell>{{ component.specification }}</clr-dg-cell>
      <clr-dg-cell>{{ component.number_of_pieces_in_stock }}</clr-dg-cell>
    </clr-dg-row>
    <clr-dg-footer>
      <clr-dg-pagination #pagination [clrDgPageSize]="50">
        <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Komponenten pro Seite</clr-dg-page-size>
        {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
        von {{ components.length }} Komponente(n)
      </clr-dg-pagination>
    </clr-dg-footer>
  </clr-datagrid>
</main>
